<div class="quot" *ngIf="quotationVersion">
  <div class="quot-header">
    <h1 class="quot-header-title lw-grey">Devis {{ quotationVersion.title }} - n°{{ quotationNumber }} <span class="quot-header-title-v">V1</span></h1>

    <div *ngIf="quotationVersion.dates.publication" class="quot-date-tile only-desktop">
      <h2 class="quot-header-date lw-light-grey">
        {{ globalFunction.formatDate(quotationVersion.dates.publication) }}
      </h2>
    </div>

    <div class="quot-price-tile">
      <h1 class="quot-header-tt-price lw-grey only-desktop">
        {{ globalDataService.financial.customer.total + getTva()  | currency: 'EUR':'symbol'}}
      </h1>
      <div [ngClass]="isDownload ? 'hide' : 'quot-header-print-logo'" (click)="downloadCustomer()"></div>
      <mat-progress-spinner [ngClass]="isDownload ? 'quot-header-print-loader' : 'hide'" [mode]="mode" [value]="value" [diameter]="diameter"></mat-progress-spinner>
    </div>
  </div>

  <section class="quot-body">
    <div *ngFor="let chapter of chapters">
      <app-chapter
        [project]="project"
        [chapter]="chapter"
        [quotation]="quotationVersion"
        [quotationId]="quotationId"
        [versionId]="versionId">
      </app-chapter>
    </div>
  </section>

  <section class="quot-footer">
    <div class="price-container">
      <div class="quot-footer-text-group">
        <h2>Montant total HT</h2>
        <h2>TVA</h2>
        <h2>Montant total options</h2>
        <h1 class="lw-light-grey">Montant total TTC</h1>
      </div>
      <div class="quot-footer-price-group">
        <h2>{{ globalDataService.financial.customer.total | currency: 'EUR':'symbol' }}</h2>
        <h2>{{getTva() | currency: 'EUR':'symbol' }}</h2>
        <h2>{{ quotationVersion.total_options_vat_excl | currency: 'EUR':'symbol' }}</h2>
        <h1>
          {{globalDataService.financial.customer.total + getTva() | currency: 'EUR':'symbol'}}
        </h1>
      </div>
    </div>
  </section>
</div>
